import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { DateInterval, Functionality, RefreshablePage } from '@financial/arch';
import { EntityCrudComponent, EntityCrudType, NumericFilterDescription, TextualFilterDescription } from '@financial/common-components';
import { ClientsBalance, ClientsBalanceRepository, CLIENTS_BALANCE } from '@financial/domain';
import * as moment from 'moment';

@Component({
  selector: 'app-clients-balance',
  templateUrl: './clients-balance.component.html',
  styleUrls: ['./clients-balance.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClientsBalanceComponent extends RefreshablePage {

  static readonly PAGE_NAME: string = "Balanço de Clientes";

  @ViewChild(EntityCrudComponent, { static: true }) crud: EntityCrudComponent;

  allowedFilters = [
    new TextualFilterDescription('name', 'Nome'),
    new NumericFilterDescription('cpf', 'CPF'),
  ];

  entityTypes: EntityCrudType[] = [
    {
      type: 'ClientsBalance',
      creator: () => new ClientsBalance(),
      title: 'ClientsBalance',
      shortTitle: 'ClientsBalance'
    }
  ];

  functionality: Functionality = CLIENTS_BALANCE;

  constructor(
    public repository: ClientsBalanceRepository
  ) {
    super();
  }

  get pageName() {
    return ClientsBalanceComponent.PAGE_NAME;
  }

  hasUnsavedState(): boolean {
    return this.crud.hasUnsavedState();
  }

  private parseDate(date: Date): string {
    const m = moment.utc(date);
    return `${m.format('YYYY-MM-DD')}T${m.format('HH:mm:ss')}Z`;
  }

  public parseString(id: string, interval: DateInterval): string {
    return `${id}--${this.parseDate(interval.begin)}--${this.parseDate(interval.end)}`;
  }

}
